import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Image } from '@chakra-ui/react';
import { assetPrefix } from '../../../../../utils';

export const DecisionTreeResultCtaRemodel: React.FC = () => {
  return (
    <div className={`mb-8 md:mb-0`}>
      <Image
        className={`w-full max-w-[400px]`}
        src={`${assetPrefix}/assets/decision-tree/remodel/images/cta-result.png`}></Image>
      <h2>
        <FormattedMessage id={`cta.remodel.header`} defaultMessage={'Mijn verbouwing tips'} />
      </h2>
      <div>
        <FormattedMessage
          id={`cta.remodel.text`}
          defaultMessage={`Of je je hypotheek kan en mag verhogen hangt ook af van je inkomen. Als je overwaarde hebt op je woning, betekent dit niet automatisch dat je je hypotheek met dat bedrag mag verhogen. Een hypotheekverhoging wordt door hypotheekverstrekkers op dezelfde manier getoetst als een nieuwe hypotheek. Onze hypotheekadviseurs zullen dus altijd inkomensgegevens vragen om te berekenen of je de nieuwe maandlasten kunt dragen.`}
        />
      </div>

      <Button
        className={`mt-8`}
        colorScheme={`orange`}
        as={`a`}
        href={`https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur/`}>
        Afspraak maken
      </Button>
    </div>
  );
};
